function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.333 2c.948 0 1.764.565 2.13 1.377-.455.073-.879.239-1.252.477a1 1 0 10-1.237 1.413 3.32 3.32 0 00-.307 1.4v.03c-1.545.156-2 .957-2 3.136 0 .064.001.12.004.167h.463a6.263 6.263 0 00-.35 1.333h-.45c-.667 0-1-.5-1-1.5 0-2.227.547-3.628 2.06-4.201A2.333 2.333 0 015.334 2zM9.79 3.854a3.313 3.313 0 00-1.251-.477 2.334 2.334 0 114.068 2.255c1.513.573 2.06 1.974 2.06 4.201 0 1-.333 1.5-1 1.5h-.45a6.267 6.267 0 00-.35-1.333h.463a3.19 3.19 0 00.004-.167c0-2.179-.456-2.98-2-3.136v-.03c0-.5-.11-.975-.307-1.4a1 1 0 10-1.237-1.413zM4.5 14.667c-.778 0-1.167-.556-1.167-1.667 0-2.54.673-4.113 2.546-4.717a2.667 2.667 0 114.242 0c1.873.604 2.546 2.177 2.546 4.717 0 1.111-.39 1.667-1.167 1.667h-7zm4.833-8a1.333 1.333 0 11-2.666 0 1.333 1.333 0 012.666 0zm2 6.333c0 .143-.008.254-.018.333h-6.63c-.01-.08-.018-.19-.018-.333 0-2.804.753-3.667 3.333-3.667s3.333.863 3.333 3.667z"
});

var SvgUserGroups = function SvgUserGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16"
  }), _ref);
};

export default SvgUserGroups;